import { ICharge } from '../interfaces/ICharge';
import { PaymentOptionType } from '../store/PaymentOption';

export function getEffectiveCharge(
    charge: ICharge,
    paymentOption: PaymentOptionType,
    // Retained for call-site compatibility. The split total is now always taken from the
    // server-computed charge.splitPaymentTotal, so these are no longer used to derive it.
    _initialSlotCount: number,
    _splitSlotCount: number
): ICharge {
    if (paymentOption === 'deposit' && (charge.depositTotal ?? 0) > 0) {
        return { ...charge, total: charge.depositTotal! };
    }
    // Always use the server-computed split total when present (even when it is 0,
    // e.g. a gift voucher fully covers the organiser's share). Never derive the split
    // amount client-side: a naive (total / slots) split ignores the voucher and add-on
    // offsets the server applies and would be wrong whenever a voucher is in play.
    if (paymentOption === 'split' && charge.splitPaymentTotal != null) {
        return { ...charge, total: charge.splitPaymentTotal };
    }
    // For 'full' payment, return the original charge object unchanged
    // to preserve referential equality and avoid unnecessary re-renders
    return charge;
}
